import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

import { ParentData, ParentService } from '../../services/parent.service';
import { Utils } from '../../util';
import { toast } from 'angular2-materialize';

@Component({
  selector: 'app-create-parent',
  templateUrl: './create-parent.component.html',
  styleUrls: ['./create-parent.component.css']
})
export class CreateParentComponent implements OnInit {

  Form: FormGroup;

  assignmentsSelect: {value: string, name: string}[];
  assignments: string[] = [];
  assignment: string = '';

  pickadateParams = Utils.pickadateParams();

  constructor(
    private service: ParentService,
    private data: ParentData,
    private fb: FormBuilder,
  ) {
     this.assignmentsSelect = Object.keys(data.assignments).map(key => {
       return {value: key, name: data.assignments[key]}
     }); 
     this.assignment = this.assignmentsSelect[0].value;
  }

  ngOnInit() {
    this.createForm();
  }

  createForm() {
    this.Form = this.fb.group({
      name: ['', Validators.required],
      birthdate: ['', Validators.required],
      semester: [1, [Validators.required, Validators.min(1), Validators.max(12)]],
    });
  }

  onSubmit({ value, valid }: { value: any, valid: boolean }) {
    let parent = {
      assignments: this.assignments,
      ...value
    }
    
    this.service.addParent(parent);
    this.service.windowReplace('read');
  }

  touchAssignment(){
    if(this.assignments.includes(this.assignment)) return toast('you can not add duplicates.', 3000);
    this.assignments.push(this.assignment)
  }
  removeAssignment(index: number){
    this.assignments.splice(index, 1);
  }

}

